// extracted by css-extract-rspack-plugin
export default {"MarkdownViewerContainer":"MarkdownViewer-module__MarkdownViewerContainer__T9V3jI2"};